<script>
import BarList from "../components/bar-list";
import PdtipoList from "../forms/pdtipo-list";
import PdstatusList from "../forms/pdstatus-list";
import RegraimpList from "../forms/regraimp-list";
import CondicaoList from "../forms/condicao-list";
import NatesList from "../forms/nates-list";
import UnimedList from "../forms/unimed-list";
import EstadoList from "../forms/estado-list";
import EquipeList from "../forms/equipe-list";
import RegrafcpList from "../forms/regrafcp-list";
import UsuarioList from "../forms/usuario-list";
import FilialList from "../forms/filial-list";
import FilialForm from "../forms/filial-form";
import CatmktList from "../forms/catmkt-list";
import CatmktForm from "../forms/catmkt-form";
import { apiORDS, apiORDSpost, urlORDS } from "../shared/api-functions";
import { SysVars } from "../main";

export default {
  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      activeTab: 0,
      isList: false
    };
  },

  components: {
    BarList,
    PdtipoList,
    PdstatusList,
    CondicaoList,
    EquipeList,
    RegraimpList,
    UsuarioList,
    FilialList,
    FilialForm,
    NatesList,
    EstadoList,
    UnimedList,
    RegrafcpList,
    CatmktList,
    CatmktForm
  },

  computed: {
    tabs: function() {
      let tabs = [];
      if (!this.perfil_usuario_comum) {
        tabs = [
          { title: "Dados da Empresa", icon: "fa-building" },
          { title: "Usuários", icon: "fa-user-o" },
          // { title: 'Equipes de Venda', icon: 'fa-group' },
          // { title: 'Condições', icon: '' },
          // { title: 'Tipos de Pedido', icon: '' },
          { title: "Unidades", icon: "" },
          { title: "Naturezas de Operação", icon: "" },
          { title: "Estados", icon: "" },
          { title: "Regras de Imposto", icon: "" },
          { title: "Alíquotas de FCP", icon: "" },
          { title: "Status de Pedido", icon: "" }
          //{ title: 'Categorias Marketplace', icon: '' },
        ];
      } else {
        tabs = [{ title: "Usuários", icon: "fa-user-o" }];
      }
      return tabs;
    },

    tabEmpresa: function() {
      return this.activeTab == 0 && !this.perfil_usuario_comum;
    },

    tabUsuarios: function() {
      if (this.perfil_usuario_comum) return this.activeTab == 0;
      else return this.activeTab == 1;
    },

    tabEquipes: function() {
      return this.activeTab == 2;
    },

    tabCondicoes: function() {
      return this.activeTab == 3;
    },

    tabStatus: function() {
      return this.activeTab == 7;
    },

    tabTipos: function() {
      return this.activeTab == 4;
    },

    tabRegras: function() {
      return this.activeTab == 5;
    },

    tabNates: function() {
      return this.activeTab == 3;
    },

    tabFcp: function() {
      return this.activeTab == 6;
    },

    tabUnimed: function() {
      return this.activeTab == 2;
    },

    tabEstado: function() {
      return this.activeTab == 4;
    },

    tabCatmkt: function() {
      return this.activeTab == 8;
    },

    perfil_usuario_comum: function() {
      return this.$store.getters.getSessao.perfil == "3";
    }
  },

  methods: {
    closeForm() {},

    changeTab(idx) {
      this.activeTab = idx;
    }
  },

  created() {}
};
</script>

<template>
  <div :class="isList ? 'd-flex col-12' : 'd-flex flex-column'">
    <!-- <bar-list
            :refresh-button="false"
            single-entity="Configurações Varejo"
            plural-entity="Configurações Varejo"
            @refresh="loadData">
        </bar-list> -->

    <div :class="isList ? 'col-2' : ''">
      <tabs
        :tabs="tabs"
        :tabindex="1"
        :isList="isList"
        :setActiveTab="activeTab"
        @onClickTab="changeTab"
      ></tabs>
    </div>

    <div class="nb-margin-top">
      <transition name="fade" mode="out-in" v-if="tabEmpresa">
        <filial-list></filial-list>
      </transition>

      <transition name="fade" mode="out-in" v-if="tabUsuarios">
        <usuario-list></usuario-list>
      </transition>

      <!-- <transition name="fade" mode="out-in" v-if="tabEquipes">
                <equipe-list></equipe-list>
            </transition> -->

      <!-- <transition name="fade" mode="out-in" v-if="tabCondicoes">
                <condicao-list></condicao-list>
            </transition> -->

      <transition name="fade" mode="out-in" v-if="tabStatus">
        <pdstatus-list></pdstatus-list>
      </transition>

      <!-- <transition name="fade" mode="out-in" v-if="tabTipos">
                <pdtipo-list></pdtipo-list>
            </transition> -->

      <transition name="fade" mode="out-in" v-if="tabRegras">
        <regraimp-list></regraimp-list>
      </transition>

      <transition name="fade" mode="out-in" v-if="tabFcp">
        <regrafcp-list></regrafcp-list>
      </transition>

      <transition name="fade" mode="out-in" v-if="tabEstado">
        <estado-list></estado-list>
      </transition>

      <transition name="fade" mode="out-in" v-if="tabUnimed">
        <unimed-list></unimed-list>
      </transition>

      <transition name="fade" mode="out-in" v-if="tabNates">
        <nates-list></nates-list>
      </transition>

      <!-- <transition name="fade" mode="out-in" v-if="tabCatmkt"> -->
      <!--     <catmkt-list></catmkt-list> -->
      <!-- </transition> -->
    </div>
  </div>
</template>

<style></style>



// WEBPACK FOOTER //
// src/forms/config-menu.vue